<template lang="pug">
	
	.albums-slider
		.movable
			.slider-container
				.slider

					.slider-movable

						.vinyl(ref='vinyl')
							img(src='assets/images/vinyl.png')

						AlbumCover(name="1999" href='https://www.youtube.com/watch?v=EJOujsrIgOc' ref="cover0" v-on:mouseenter.native="onHover($event,0)" v-on:mouseleave.native="onHover($event,0)")
						AlbumCover(name="rejex" href='https://www.youtube.com/watch?v=WI92jrybHPo&list=PLMyw0dWAIHv4R7sjh-Iga4KaeioA34m4B' ref="cover1" v-on:mouseenter.native="onHover($event,1)" v-on:mouseleave.native="onHover($event,1)")
						
						.albums-story
							p.text {{translate('badass.between_albums')}}

						AlbumCover(name="summer" href='https://www.youtube.com/watch?v=jZr_aKxwk7g' ref="cover2" v-on:mouseenter.native="onHover($event,2)" v-on:mouseleave.native="onHover($event,2)")
						AlbumCover(name="badass" href='https://www.youtube.com/watch?v=fyZPH7kbFZ8' ref="cover3" v-on:mouseenter.native="onHover($event,3)" v-on:mouseleave.native="onHover($event,3)")


</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import { TweenMax } from 'gsap'

	import Scrollable from '~abstracts/scrollable'
	import AlbumCover from './album-cover.vue'
	import Globals from '~utils/Globals'

  	@Component({
		name: 'BadassOriginsAlbums',
		components: {AlbumCover }
	})

	class BadassOriginsAlbums extends Scrollable {

		mounted () {
			super.mounted()
			
			this.count = 0

			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
			
			this.$slider = this.$el.querySelector('.slider-movable')
			this.$movable = this.$el.querySelector('.movable')
			this.$vinyl = this.$el.querySelector('.vinyl')

		}

		onHover (e,i) {
			
			const direction = e.type === "mouseenter" ? 'in' : 'out'

			this.setVinylPosition(i,direction)
		}

		setVinylPosition (i,direction) {
			const r = this.$refs[`cover${i}`].$el
			const l = r.getBoundingClientRect().left
			const w = this.$vinyl.getBoundingClientRect().width
			const offset = this.bounds.top - _.clamp(Math.abs(this.scroller.scroll.lerped),this.bounds.top, (this.bounds.top + this.offsetAnim))
			const toLeft = l - offset
			const elw = r.getBoundingClientRect().width

			if(direction === 'in') {
				TweenMax.to(this.$vinyl,.4,{x: toLeft + w*.4})
			} else if(direction === 'out') {
				TweenMax.to(this.$vinyl,.3,{x: toLeft})
			}
		}

		initTimeline () {
			super.initTimeline()

			this.tl.fromTo(this.$movable,1,{y:0},{y:this.offsetAnim,ease:Power0.easeNone},0)
			this.tl.fromTo(this.$slider,1,{x:0},{x:-this.offsetAnim,ease:Power0.easeNone},0)
		}

		_points () {

		}

		resizeVinyl () {
			this.$refs.vinyl.style.height = Globals.responsiveHeight(330) + "px"
			this.$refs.vinyl.style.width = Globals.responsiveHeight(330) * 370 / 330 + "px"
		}

		_resize () {
			super._resize()

			this.resizeVinyl()
			this.setVinylPosition(0,'out')

			this.sliderWidth = this.$slider.getBoundingClientRect().width
			this.offsetAnim = this.sliderWidth - window.innerWidth

			this.bounds.height = window.innerHeight + this.offsetAnim
			this.$el.style.height = this.bounds.height + "px"


			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.offsetAnim
			}

			this.initTimeline () 
			this._points()
		}

		raf (y) {
			super.raf(y)	
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default BadassOriginsAlbums

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.albums-slider
		width 100%
		height 100vh
		position relative

		.movable
			height 100vh
			width 100%
			position absolute
			top 0
			left 0
			will-change transform

			.slider-movable
				position relative

				.album-cover
					&:nth-child(2)
						z-index 50

					&:nth-child(3)
						z-index 40

					&:nth-child(5)
						z-index 20

					&:nth-child(6)
						z-index 10

			.vinyl
				position absolute
				top 2px
				left 0
				padding 20px
				box-sizing border-box

				img 
					height 100%

			.slider-container
				width 100%
				height 100%
				display flex
				align-items center
				position relative
				overflow hidden

				.slider
					width 999999px
					display flex
				
					.slider-movable
						display flex
						align-items center
						padding 0 90px
						padding-right 190px
						will-change transform
					
				.albums-story
					width 350px
					margin-left 190px
					position relative
					z-index 30

					+break(minlg)
						width 550px

					.text
						color #fff
						font-size em(18px)
						line-height em(24px,18px)
						font-family $FONT_THIRDLY

						span
							text-decoration underline
							font-family $FONT_PRIMARY

	
</style>


// WEBPACK FOOTER //
// albums-slider.vue?a07ff158